<template>
  <div>
    <vs-row vs-type="flex" vs-align="flex-end">
      <vs-col vs-lg="3" vs-sm="12" class="h100">
        <p>Filtrar por Data:</p>
      </vs-col>
      <vs-col vs-w="4.5" vs-sm="12">
        <vs-input type="date" label="Data Inicial" v-model="date.inicialDate" />
      </vs-col>
      <vs-col vs-w="4.5" vs-sm="12">
        <vs-input type="date" label="Data Final" v-model="date.finalDate" />
      </vs-col>
      <vs-col>
        <vs-button
          icon="tune"
          color="primary"
          class="w100"
          type="filled"
          @click="findBy()"
        >
          Filtrar Resultados
        </vs-button>
      </vs-col>
    </vs-row>
    <vs-divider />
    <vs-row
      v-if="
        myPreRegistation.length > 0 ||
        statusFilter != null ||
        taxFilter != null ||
        sellerFilter != null
      "
      style="margin-bottom: 5px"
    >
      <vs-col vs-w="4" vs-sm="12" vs-xs="12">
        <fieldset style="display: flex; border-radius: 8.5px; padding: 5px">
          <vs-select
            name="status"
            width="100%"
            v-model="statusFilter"
            placeholder="Selecione um Status"
            @change="findMatriculation()"
          >
            <vs-select-item
              :key="index"
              :value="option.STATUS"
              :text="option.STATUS.toUpperCase()"
              v-for="(option, index) in typeStatus"
            />
          </vs-select>
        </fieldset>
      </vs-col>
      <vs-col vs-w="4" vs-sm="12" vs-xs="12">
        <fieldset style="display: flex; border-radius: 8.5px; padding: 5px">
          <vs-input
            v-model="sellerFilter"
            placeholder="Digite um Vendedor"
            type="text"
            @blur="findMatriculation"
            @keyup.enter="findMatriculation"
          />
        </fieldset>
      </vs-col>
      <vs-col vs-w="4" vs-sm="12" vs-xs="12">
        <fieldset style="display: flex; border-radius: 8.5px; padding: 5px">
          <vs-select
            name="status"
            width="100%"
            v-model="taxFilter"
            placeholder="Selecione uma Taxa (R$)"
            @change="findMatriculation()"
          >
            <vs-select-item
              :key="index"
              :value="option.TAX"
              :text="'R$ ' + option.TAX"
              v-for="(option, index) in typeTax"
            />
          </vs-select>
        </fieldset>
      </vs-col>
    </vs-row>
    <vs-table
      v-if="myPreRegistation.length > 0"
      class="pd-table"
      :max-items="descriptionItems[0]"
      pagination
      :data="myPreRegistation"
      description
      :description-items="descriptionItems"
      description-title="Registros"
      description-connector="de"
      description-body="Mostrar"
      search
    >
      <template slot="thead">
        <th>Detalhe</th>
        <th>Atendimento/Pré/Etapa</th>
        <th>Aluno/Responsável</th>
        <th>Curso</th>
        <th>Status</th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr
          :style="
            data[indextr].INCONSISTENCIA == '1'
              ? 'background-color: #FBFF82'
              : ''
          "
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td>
            <vs-button
              @click="openDetail(data[indextr])"
              color="primary"
              type="filled"
              icon="arrow_forward"
            />
          </vs-td>
          <vs-td>
            <div class="b__important" style="margin-bottom: 1.5px">
              {{ data[indextr].CODATENDIMENTO }} -
              {{ data[indextr].IDPREMATRICULA }}
            </div>
            <div class="b__small" style="margin-bottom: 5px">
              {{ data[indextr].ETAPA.toUpperCase() }}
            </div>
            <div class="b__small" style="margin-bottom: 5px">
              <div style="display: flex">
                <span
                  style="font-size: 12.5px; margin-right: 2.5px"
                  class="material-icons"
                >
                  account_circle
                </span>
                <span>
                  {{ data[indextr].NOMEVENDEDOR }}
                </span>
              </div>
            </div>
            <div class="b__small">
              <div style="display: flex">
                <span
                  style="font-size: 12.5px; margin-right: 2.5px"
                  class="material-icons"
                >
                  monetization_on
                </span>
                <span>
                  R$ {{ Number(data[indextr].VALORTAXALIQUIDO1).toFixed(2) }}
                </span>
              </div>
              <div style="display: flex">
                <span
                  style="font-size: 12.5px; margin-right: 2.5px"
                  class="material-icons"
                >
                  event
                </span>
                <span>
                  {{ data[indextr].DTVENCIMENTOTAXA | moment }}
                </span>
              </div>
              <div style="display: flex" v-if="data[indextr].DATAEFETIVACAO || (data[indextr].REAPROVEITAMENTO == '1' && data[indextr].DATABAIXAREAPROVEITADA)">
                <span style="font-size: 12.5px; margin-right: 2.5px" class="material-icons">
                  check_circle
                </span>
                <span>
                  {{ (data[indextr].REAPROVEITAMENTO == '1' && data[indextr].DATABAIXAREAPROVEITADA ? data[indextr].DATABAIXAREAPROVEITADA : data[indextr].DATAEFETIVACAO) | moment }}
                </span>
              </div>
            </div>
          </vs-td>
          <vs-td>
            <div class="b__important">
              {{ data[indextr].ALUNO.toUpperCase() }}
            </div>
            <div style="margin-bottom: 2.5px">RA: {{ data[indextr].RA }}</div>
            <div class="b__small">
              ({{ data[indextr].CODCLIENTE }}) {{ data[indextr].NOMECLIENTE }}
            </div>
          </vs-td>
          <vs-td>
            <div class="b__small">{{ data[indextr].CURSO }}</div>
          </vs-td>
          <vs-td>
            <div
              :style="formatStatus(data[indextr].STATUS)"
              style="margin-bottom: 3.5px"
              class="b__important"
            >
              {{ data[indextr].STATUS.toUpperCase() }}
            </div>
            <div class="b__small">
              <div style="display: flex">
                <span
                  style="font-size: 12.5px; margin-right: 2.5px"
                  class="material-icons"
                >
                  event
                </span>
                <span>
                  {{ data[indextr].DTCRIACAO | moment }}
                </span>
              </div>
              <div style="display: flex" v-if="data[indextr].DATAEFETIVACAO">
                <span
                  style="font-size: 12.5px; margin-right: 2.5px"
                  class="material-icons"
                >
                  check_circle
                </span>
                <span>
                  {{ data[indextr].DATAEFETIVACAO | moment }}
                </span>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-popup
      :title="'Atendimento - ' + selectedPreRegistration.CODATENDIMENTO"
      :active.sync="showDetail"
      class="text-align"
    >
      <vs-card>
        <vs-tabs alignment="center">
          <vs-tab icon="info" label="Informações da Pré">
            <vs-row class="border_col">
              <vs-col vs-w="6">
                <div class="b__small">Pré Matrícula</div>
                <div class="b__important">
                  {{ selectedPreRegistration.IDPREMATRICULA }}
                </div>
              </vs-col>
              <vs-col vs-w="6">
                <div class="b__small">Vencimento Taxa</div>
                <div class="b__important">
                  {{ selectedPreRegistration.DTVENCIMENTOTAXA | moment }}
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="border_col">
              <vs-col vs-w="6">
                <div class="b__small">Valor da Taxa com desconto</div>
                <div class="b__important">
                  R$
                  {{
                    (
                      parseFloat(selectedPreRegistration.VALORTAXA) -
                      (parseFloat(selectedPreRegistration.VALORTAXA) *
                        parseFloat(selectedPreRegistration.DESCONTOTAXA)) /
                        100
                    ).toFixed(2)
                  }}
                </div>
              </vs-col>
              <vs-col vs-w="6">
                <div class="b__small">Baixa Taxa</div>
                <div class="b__important" v-if="payTax">
                  {{ payTax | moment }}
                </div>
                <div class="b__important" v-else>
                  -
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="border_col">
              <vs-col vs-w="6">
                <div class="b__small">Parcelas</div>
                <div class="b__important">
                  {{ selectedPreRegistration.NUMPARCELA }}x de R${{
                    selectedPreRegistration.VALORPARCELA
                  }}
                  (R${{
                    Number(
                      selectedPreRegistration.NUMPARCELA *
                        selectedPreRegistration.VALORPARCELA
                    ).toFixed(2)
                  }})
                </div>
              </vs-col>
              <vs-col vs-w="6">
                <div class="b__small">Vencimento 1ª Parcela</div>
                <div class="b__important">
                  {{ selectedPreRegistration.DTVENCIMENTOPARC | moment }}
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="border_col" v-if="hasScholarships">
              <vs-col vs-w="12">
                <div class="b__small">Bolsas adicionadas</div>
                <div
                  class="b__important"
                  v-for="scholarship in scholarships"
                  :key="scholarship.CODBOLSA"
                >
                  {{ scholarship.BOLSA }} - {{ scholarship.PERCDESCONTO }}% da
                  parcela {{ scholarship.PARCELAINICIAL }} a
                  {{ scholarship.PARCELAFINAL }}
                </div>
              </vs-col>
            </vs-row>

            <vs-row vs-type="flex" vs-justify="center" vs-align="center">
              <vs-col
                v-if="
                  selectedPreRegistration.CONTEXTO == 'Supervisor' &&
                  selectedPreRegistration.INCONSISTENCIA == 1 ||
                  selectedPreRegistration.CONTEXTO == 'Vendedor' &&
                  selectedPreRegistration.INCONSISTENCIA == 1
                "
                vs-w="6"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  color="#139B0E"
                  icon="check_circle"
                  type="filled"
                  class="w-100"
                  @click="openDivergence(selectedPreRegistration)"
                  >Divergência Corrigida</vs-button
                >
              </vs-col>
              <vs-col
                v-if="
                  selectedPreRegistration.EDITAVEL == 1 &&
                  (selectedPreRegistration.CONTEXTO == 'Supervisor' ||
                    selectedPreRegistration.CONTEXTO == 'Coordenador')
                "
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="edit"
                  color="#ffa500"
                  type="filled"
                  class="w-100"
                  @click="
                    startEditPre(
                      selectedPreRegistration,
                      selectedPreRegistration.CODATENDIMENTO,
                      selectedPreRegistration.CODCOLIGADA,
                      selectedPreRegistration.CODLOCAL,
                      selectedPreRegistration.IDPREMATRICULA
                    )
                  "
                  >Editar Pré</vs-button
                >
              </vs-col>
              <vs-col
                v-if="selectedPreRegistration.RELANCAR == 1"
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="refresh"
                  color="success"
                  type="filled"
                  class="w-100"
                  @click="
                    startSimulation(
                      selectedPreRegistration.CODATENDIMENTO,
                      selectedPreRegistration.CODCOLIGADA,
                      selectedPreRegistration.CODLOCAL,
                      selectedPreRegistration.IDPREMATRICULA
                    )
                  "
                  >Relançar Pré</vs-button
                >
              </vs-col>
              <vs-col
                v-if="selectedPreRegistration.DESCARTAR == 1"
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="delete"
                  type="filled"
                  class="w-100"
                  @click="confirmDisposal()"
                  >Descartar Pré</vs-button
                >
              </vs-col>

              <vs-col
                v-if="selectedPreRegistration.APROVAR == '1'"
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="check_circle"
                  type="filled"
                  class="w-100"
                  @click="aprove()"
                  >Aprovar Negociação</vs-button
                >
              </vs-col>
              <vs-col
                v-if="selectedPreRegistration.APROVAR == 1"
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="highlight_off"
                  type="filled"
                  class="w-100"
                  @click="reprove()"
                  >Reprovar Negociação</vs-button
                >
              </vs-col>
              <vs-col
                v-if="
                  selectedPreRegistration.CANCELAR == 1 ||
                  selectedPreRegistration.INCONSISTENCIA == 1
                "
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="highlight_off"
                  type="filled"
                  class="w-100"
                  @click="cancel()"
                  >Cancelar Pré</vs-button
                >
              </vs-col>

              <vs-col
                v-if="
                  selectedPreRegistration.CODSTATUS != 'CN' &&
                  selectedPreRegistration.CODSTATUS != 'CA'
                "
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="edit"
                  type="filled"
                  color="danger"
                  class="w-100"
                  @click="editEmail = true"
                >
                  Email do Cliente
                </vs-button>
              </vs-col>

              <vs-col
                v-if="
                  selectedPreRegistration.CODSTATUS != 'CN' &&
                  selectedPreRegistration.CODSTATUS != 'CA'
                "
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="edit"
                  type="filled"
                  color="danger"
                  class="w-100"
                  @click="editTelephone = true"
                >
                  Telefone do Cliente
                </vs-button>
              </vs-col>

              <vs-col
                v-if="selectedPreRegistration.CODSTATUS == 'RE' && payTax == undefined"
                vs-w="6"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="email"
                  color="#139B0E"
                  type="filled"
                  class="w-100"
                  @click="resendTax()"
                >
                  Taxa pelo Email
                </vs-button>
              </vs-col>

              <vs-col
                v-if="selectedPreRegistration.CODSTATUS == 'RE' && payTax == undefined"
                vs-w="6"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="phone"
                  color="#139B0E"
                  type="filled"
                  class="w-100"
                  @click="resendTaxWhats()"
                >
                  Taxa pelo WhatsApp
                </vs-button>
              </vs-col>

              <vs-col
                v-if="
                  selectedPreRegistration.CANCELAR == 1 &&
                  selectedPreRegistration.CODSTATUS == 'RE' &&
                  selectedPreRegistration.URLPIX != '*'
                "
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="monetization_on"
                  type="filled"
                  class="w-100"
                  :href="selectedPreRegistration.URLPIX"
                  target="_blank"
                  >Link PIX</vs-button
                >
              </vs-col>

              <vs-col
                v-if="
                  selectedPreRegistration.AVANCAR == 1 &&
                  (selectedPreRegistration.CODSTATUS == 'AP' ||
                    selectedPreRegistration.TIPOTAXA != 'I' ||
                    scholarshipCoordinator)
                "
                vs-w="4"
                vs-xs="12"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  icon="monetization_on"
                  color="#139B0E"
                  type="filled"
                  class="w-100"
                  @click="gotoSecretary()"
                  >Reservar Pré</vs-button
                >
              </vs-col>
            </vs-row>
            <vs-row v-if="editDivergence == true">
              <vs-divider />
              <vs-col vs-type="flex">
                <vs-input
                  name="ORIENTACAO"
                  v-model="correctionDivergence"
                  icon-no-border
                  icon="help"
                  label="Orientação Rápida"
                />
              </vs-col>
              <vs-button
                icon="check"
                type="filled"
                class="w-100"
                :disabled="!correctionDivergence"
                @click="divergenceCorrected(correctionDivergence)"
              >
                Encaminhar para Auditoria
              </vs-button>
            </vs-row>
            <vs-row v-if="editEmail == true">
              <vs-divider />
              <vs-col vs-type="flex" vs-w="12">
                <vs-input
                  name="EMAIL"
                  type="email"
                  v-model="emailEdited"
                  icon-no-border
                  icon="email"
                  label="Email do Cliente"
                  :placeholder="this.clientResult.EMAIL"
                  :danger="!emailEdited > 0 || !validEmail(emailEdited)"
                  danger-text="Informe um e-mail válido."
                  class="w-100"
                />
              </vs-col>
              
              <vs-col vs-w="12" style="margin-top: 10px; margin-bottom: 10px;">
                <div style="display: flex; align-items: center; color: #900020;">
                  <span style="font-size: 16px; margin-right: 5px;" class="material-icons">
                    info
                  </span>
                  <span style="font-size: 11px; font-weight: 600;">
                    A minuta do contrato e a taxa (caso não esteja paga) serão enviadas automaticamente para o novo e-mail após a edição.
                  </span>
                </div>
              </vs-col>
              <vs-col v-if="emailEdited == this.clientResult.EMAIL">
                <b style="color: red !important">
                  O email precisa ser diferente do atual
                </b>
              </vs-col>
              <vs-button
                icon="edit"
                type="filled"
                class="w-100"
                :disabled="
                  !validEmail(emailEdited) ||
                  emailEdited == this.clientResult.EMAIL
                "
                @click="emailEdit()"
              >
                Editar Email
              </vs-button>
            </vs-row>
            <vs-row v-if="editTelephone == true">
              <vs-divider />
              <vs-col vs-type="flex">
                <vs-input
                  name="TELEFONE"
                  type="text"
                  v-model="telephoneEdited"
                  icon-no-border
                  icon="phone_iphone"
                  v-mask="'###########'"
                  label="Telefone do Cliente"
                  :placeholder="this.clientResult.TELEFONE1"
                  :danger="!validTelephone(telephoneEdited)"
                  danger-text="Informe um telefone válido."
                />
              </vs-col>
              <vs-col v-if="telephoneEdited == this.clientResult.TELEFONE1">
                <b style="color: red !important">
                  O telefone precisa ser diferente do atual
                </b>
              </vs-col>
              <vs-button
                icon="edit"
                type="filled"
                class="w-100"
                :disabled="
                  !validTelephone(telephoneEdited) ||
                  telephoneEdited == this.clientResult.TELEFONE1
                "
                @click="telephoneEdit()"
              >
                Editar Telefone
              </vs-button>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                class="flex-gap"
              >
                <div class="b__small">
                  Vendedor: {{ selectedPreRegistration.USUVENDEDOR }}
                </div>
                <div class="b__small">
                  Supervisor: {{ selectedPreRegistration.USUSUPERVISOR }}
                </div>
                <div class="b__small">
                  Coordenador: {{ selectedPreRegistration.USUCOORDENADOR }}
                </div>
                <div class="b__small">
                  Contexto: {{ selectedPreRegistration.CONTEXTO }}
                </div>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                class="flex-gap"
              >
                <vs-alert
                  color="success"
                  :active.sync="successAdvance"
                  close-icon="close"
                  title="Operação realizada com sucesso!"
                >
                  <span>{{ message }}</span>
                </vs-alert>
                <vs-alert
                  color="danger"
                  :active.sync="error"
                  close-icon="close"
                >
                  <p v-for="(erro, i) in errors" :key="i">{{ erro }}</p>
                </vs-alert>
              </vs-col>
            </vs-row>
          </vs-tab>
          <vs-tab icon="group" label="Discussão">
            <p v-html="discussion"></p>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </vs-popup>
    <vs-alert
      color="danger"
      icon="new_releases"
      v-if="myPreRegistation.length == 0"
    >
      <b>Sem resultados para serem mostrados</b>
    </vs-alert>
  </div>
</template>

<script>
import preRegistration from "../../services/preRegistration";
import Mailing from "../../services/mailing";
import PersonService from "../../services/person";
import Financial from "../../services/financial";
import moment from "moment";
import {
  formatDateToUSA,
  updateStepsInformation,
  onlyUpdateDiscussion,
  getLoginDataFromStorage,
  notifyError,
  notifySuccess,
} from "../../helpers";
export default {
  name: "MyPreRegistration",
  data: () => ({
    date: {
      inicialDate: "",
      finalDate: "",
    },
    today: moment().format("YYYY-MM-DD"),
    fortnight: {
      inicialDate: moment().startOf("month").format("YYYY-MM-DD"),
      middleDate: moment().startOf("month").add(15, "day").format("YYYY-MM-DD"),
    },
    descriptionItems: [10, 50, 100],
    myPreRegistation: [],
    profiles: [],
    showDetail: false,
    selectedPreRegistration: {
      CODCOLIGADA: "",
      CODLOCAL: "",
      IDPREMATRICULA: "",
      CODATENDIMENTO: "",
      NUMPARCELA: "",
      VALORPARCELA: "",
      VALORTAXA: "",
      DTVENCIMENTOTAXA: "",
      DTVENCIMENTOPARC: "",
      EDITAVEL: "",
      RELANCAR: "",
      DESCARTAR: "",
      USUSUPERVISOR: "",
      CONTEXTO: "",
      APROVAR: "",
      AVANCAR: "",
      USUTELEAGENDADOR: "",
      USUVENDEDOR: "",
      RA: "",
      CODCONTRATO: "",
    },
    client: {
      NOMEFANTASIA: "",
      NOME: "",
      CGCCFO: "",
      TELEFONE: "",
      TELEX: "",
      EMAIL: "",
      PESSOAFISOUJUR: "",
      DTNASCIMENTO: "",
      isNew: false,
      RUA: "",
      CEP: "",
      NUMERO: "",
      CODMUNICIPIO: "",
      ESTADO: "",
      BAIRRO: "",
      TIPORUA: "",
    },
    scholarships: null,
    subjects: null,
    error: null,
    statusFilter: null,
    typeStatus: [
      { STATUS: "Aguardando Aprovação Coordenador" },
      { STATUS: "Aguardando Aprovação Supervisor" },
      { STATUS: "Aguardando Vestibular" },
      { STATUS: "Aprovada" },
      { STATUS: "Cancelada" },
      { STATUS: "Concluída" },
      { STATUS: "Confirmada" },
      { STATUS: "Criada" },
      { STATUS: "Reprovada" },
      { STATUS: "Reservada" },
    ],
    taxFilter: null,
    typeTax: [
      { TAX: "0.00" },
      { TAX: "98.91" },
      { TAX: "99.00" },
      { TAX: "120.00" },
      { TAX: "150.00" },
      { TAX: "199.98" },
      { TAX: "300.00" },
    ],
    sellerFilter: null,
    typeSeller: [],
    discussion: null,
    payTax: null,
    titleClient: null,
    colorClient: null,
    alertClient: null,
    successAdvance: false,
    message: null,
    errors: [],
    emailEdited: null,
    telephoneEdited: null,
    correctionDivergence: null,
    divergenceInfo: [],
    scholarshipCoordinator: false,
    editDivergence: false,
    editEmail: false,
    editTelephone: false,
    hasScholarships: false,
    successDisposal: false,
  }),
  mounted() {
    const { ...user } = getLoginDataFromStorage();
    this.profiles = user.profiles;

    const profileCoordinator = this.profiles.find(
      (element) => element == "SupervisorVenda"
    );

    if (profileCoordinator) {
      this.scholarshipCoordinator = true;
    } else {
      this.scholarshipCoordinator = false;
    }

    this.init();
  },
  methods: {
    findMatriculation() {
      this.$vs.loading();
      new preRegistration()
        .searchByDate(this.date)
        .then((res) => {
          let filteredResults = res.data;

          if (this.statusFilter) {
            filteredResults = filteredResults.filter(
              (a) => a.STATUS === this.statusFilter
            );
          }

          if (this.taxFilter) {
            filteredResults = filteredResults.filter(
              (a) => Number(a.VALORTAXALIQUIDO).toFixed(2) === this.taxFilter
            );
          }

          if (this.sellerFilter) {
            filteredResults = filteredResults.filter((a) =>
              a.NOMEVENDEDOR.toLowerCase().includes(
                this.sellerFilter.toLowerCase()
              )
            );
          }

          this.myPreRegistation = filteredResults;
          this.$vs.loading.close();
        })
        .catch(({ error }) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },

    removeDuplicates(items) {
      let noDuplicates = [];
      for (let i = 0; i < items.length; i++) {
        let duplicate = false;
        for (let j = 0; j < noDuplicates.length; j++) {
          if (items[i].STATUS == noDuplicates[j].STATUS) {
            duplicate = true;
          }
        }

        if (!duplicate) {
          noDuplicates.push(items[i]);
        }
      }

      noDuplicates.sort((a, b) => a.STATUS.localeCompare(b.STATUS));

      return noDuplicates;
    },
    formatStatus(status) {
      switch (status) {
        case "Criada":
          return "color: #0000ff;";
        case "Concluída":
          return "color: #008000;";
        case "Confirmada":
        case "Aprovada":
          return "color: #00AA00;";
        case "Reservada":
        case "Aguardando Aprovação Supervisor":
        case "Aguardando Aprovação Coordenador":
          return "color: #ffa500;";
        case "Cancelada":
        case "Descartada":
        case "Reprovada":
          return "color: #ff0000;";
      }
    },
    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validTelephone(telephone) {
      var re = /^\d{11}$/;
      return re.test(telephone);
    },
    async emailEdit() {
      this.$vs.loading();
      this.showDetail = false;

      const clientData = {
        NOMEFANTASIA: this.clientResult.NOME,
        NOME: this.clientResult.NOME,
        CGCCFO: this.clientResult.CPFCNPJ.replace(/\D/g, ""),
        TELEFONE: this.clientResult.TELEFONE1.replace(/\D/g, ""),
        TELEX: this.clientResult.TELEFONE2.replace(/\D/g, ""),
        EMAIL: this.emailEdited,
        PESSOAFISOUJUR: this.clientResult.PESSOAFISOUJUR,
        DTNASCIMENTO: formatDateToUSA(this.clientResult.DTNASCIMENTO),
        CODCOLCFO: this.clientResult.CODCOLIGADA,
        CODCFO: this.clientResult.CODCFO,
        CIDENTIDADE: this.clientResult.RG,
        CEP: this.clientResult.CEP == "-" ? "" : this.clientResult.CEP,
        RUA: this.clientResult.RUA == "-" ? "" : this.clientResult.RUA,
        NUMERO: this.clientResult.NUMERO == "-" ? "" : this.clientResult.NUMERO,
        COMPLEMENTO: this.clientResult.COMPLEMENTO,
        CODETD: this.clientResult.ESTADO == "-" ? "" : this.clientResult.ESTADO,
        CODMUNICIPIO:
          this.clientResult.CODMUNICIPIO == "-"
            ? ""
            : this.clientResult.CODMUNICIPIO,
        BAIRRO: this.clientResult.BAIRRO == "-" ? "" : this.clientResult.BAIRRO,
        TIPORUA:
          this.clientResult.TIPORUA == "-" ? "" : this.clientResult.TIPORUA,
        isNew: false,
      };

      try {
        await new PersonService().newClientPerson(clientData);

        onlyUpdateDiscussion(
          "Alterou o e-mail do cliente \nDE: " + this.clientResult.EMAIL + "\nPARA: " + this.emailEdited,
          this.selectedPreRegistration.CODCOLIGADA,
          this.selectedPreRegistration.CODLOCAL,
          this.selectedPreRegistration.CODATENDIMENTO
        );

        const payloadDraft = {
          CODCOLIGADA: this.selectedPreRegistration.CODCOLIGADA,
          IDPREMATRICULA: this.selectedPreRegistration.IDPREMATRICULA,
          workflow: "509",
        };
        
        await this.resendContractDraft(payloadDraft);

        onlyUpdateDiscussion(
          "Minuta reenviada para o novo e-mail: " + this.emailEdited,
          this.selectedPreRegistration.CODCOLIGADA,
          this.selectedPreRegistration.CODLOCAL,
          this.selectedPreRegistration.CODATENDIMENTO
        );

        if (this.selectedPreRegistration.CODSTATUS == "RE" && this.payTax == undefined) {
          
          const payloadTax = {
            colligateId: this.selectedPreRegistration.CODCOLIGADA,
            preRegistrationId: this.selectedPreRegistration.IDPREMATRICULA,
            contractId: this.selectedPreRegistration.CODCONTRATO,
            ra: this.selectedPreRegistration.RA,
            workflow: "250",
          };

          await new Financial().resendTax(payloadTax);

          onlyUpdateDiscussion(
            "Taxa reenviada para o novo e-mail: " + this.emailEdited,
            this.selectedPreRegistration.CODCOLIGADA,
            this.selectedPreRegistration.CODLOCAL,
            this.selectedPreRegistration.CODATENDIMENTO
          );
        }

        this.$vs.notify({
          title: "Sucesso",
          text: "Email editado e operações concluídas com sucesso.",
          color: "success",
          position: "top-center",
        });

      } catch (error) {
        notifyError(this, "Erro durante a operação: " + (error.response?.data?.error || error));
      } finally {
        this.$vs.loading.close();
      }
    },

    async resendContractDraft(payload) {
      return new Financial().resendContractDraft(payload);
    },

    telephoneEdit() {
      this.$vs.loading();
      const clientData = {
        NOMEFANTASIA: this.clientResult.NOME,
        NOME: this.clientResult.NOME,
        CGCCFO: this.clientResult.CPFCNPJ.replace(/\D/g, ""),
        TELEFONE: this.telephoneEdited.replace(/\D/g, ""),
        TELEX: this.clientResult.TELEFONE2.replace(/\D/g, ""),
        EMAIL: this.clientResult.EMAIL,
        PESSOAFISOUJUR: this.clientResult.PESSOAFISOUJUR,
        DTNASCIMENTO: formatDateToUSA(this.clientResult.DTNASCIMENTO),
        CODCOLCFO: this.clientResult.CODCOLIGADA,
        CODCFO: this.clientResult.CODCFO,
        CIDENTIDADE: this.clientResult.RG,
        CEP: this.clientResult.CEP == "-" ? "" : this.clientResult.CEP,
        RUA: this.clientResult.RUA == "-" ? "" : this.clientResult.RUA,
        NUMERO: this.clientResult.NUMERO == "-" ? "" : this.clientResult.NUMERO,
        COMPLEMENTO: this.clientResult.COMPLEMENTO,
        CODETD: this.clientResult.ESTADO == "-" ? "" : this.clientResult.ESTADO,
        CODMUNICIPIO:
          this.clientResult.CODMUNICIPIO == "-"
            ? ""
            : this.clientResult.CODMUNICIPIO,
        BAIRRO: this.clientResult.BAIRRO == "-" ? "" : this.clientResult.BAIRRO,
        TIPORUA:
          this.clientResult.TIPORUA == "-" ? "" : this.clientResult.TIPORUA,
        isNew: false,
      };
      this.showDetail = false;

      if (this.selectedPreRegistration.CODSTATUS == "RE" && this.payTax == undefined) {
        new PersonService()
          .newClientPerson(clientData)
          .then(({ data }) => {
            const result = data.split(";");
            console.log(result);

            onlyUpdateDiscussion(
              "Alterou o telefone do cliente \n" +
                "DE: " +
                this.clientResult.TELEFONE1 +
                "\n" +
                "PARA: " +
                this.telephoneEdited,
              this.selectedPreRegistration.CODCOLIGADA,
              this.selectedPreRegistration.CODLOCAL,
              this.selectedPreRegistration.CODATENDIMENTO
            );

            this.$vs.notify({
              title: "Sucesso",
              text: "Telefone do cliente editado com sucesso.",
              color: "success",
              position: "top-center",
            });
          })
          .catch(( errorClient ) => {
            notifyError(
              this,
              "Erro na tentativa de criar ou atualizar um registro de cliente: " + errorClient.response.data.error
            );
          });

        const payload = {
          colligateId: this.selectedPreRegistration.CODCOLIGADA,
          preRegistrationId: this.selectedPreRegistration.IDPREMATRICULA,
          contractId: this.selectedPreRegistration.CODCONTRATO,
          ra: this.selectedPreRegistration.RA,
          workflow: "363",
        };
        new Financial()
          .resendTax(payload)
          .then(() => {
            onlyUpdateDiscussion(
              "Taxa reenviada para o WhatsApp: " + this.telephoneEdited,
              this.selectedPreRegistration.CODCOLIGADA,
              this.selectedPreRegistration.CODLOCAL,
              this.selectedPreRegistration.CODATENDIMENTO
            );

            this.$vs.notify({
              title: "Sucesso",
              text: "Taxa reenviada com sucesso.",
              color: "success",
              position: "top-center",
            });
          })
          .catch((error) => {
            notifyError(this, "Erro ao tentar reenviar a taxa: " + error);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } else {
        new PersonService()
          .newClientPerson(clientData)
          .then(({ data }) => {
            const result = data.split(";");
            console.log(result);

            onlyUpdateDiscussion(
              "Alterou o telefone do cliente \n" +
                "DE: " +
                this.clientResult.TELEFONE1 +
                "\n" +
                "PARA: " +
                this.telephoneEdited,
              this.selectedPreRegistration.CODCOLIGADA,
              this.selectedPreRegistration.CODLOCAL,
              this.selectedPreRegistration.CODATENDIMENTO
            );

            this.$vs.notify({
              title: "Sucesso",
              text: "Telefone do cliente editado com sucesso.",
              color: "success",
              position: "top-center",
            });
          })
          .catch(( errorClient ) => {
            notifyError(
              this,
              "Erro na tentativa de criar ou atualizar um registro de cliente: " + errorClient.response.data.error
            );
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },

    startSimulation(
      codAtendimento,
      codColigada,
      codLocal,
      preRegistrationIdRel
    ) {
      updateStepsInformation({
        codAtendimento: codAtendimento,
        codColigada: codColigada,
        codLocal: codLocal,
        preRegistrationIdRel: preRegistrationIdRel,
      });
      this.$router.push("/courses");
    },

    async resendTax() {
      this.showDetail = false;
      this.$vs.loading();
      const payload = {
        colligateId: this.selectedPreRegistration.CODCOLIGADA,
        preRegistrationId: this.selectedPreRegistration.IDPREMATRICULA,
        contractId: this.selectedPreRegistration.CODCONTRATO,
        ra: this.selectedPreRegistration.RA,
        workflow: "250",
      };
      await new Financial()
        .resendTax(payload)
        .then(() => {
          onlyUpdateDiscussion(
            "Taxa reenviada para o e-mail: " + this.clientResult.EMAIL,
            this.selectedPreRegistration.CODCOLIGADA,
            this.selectedPreRegistration.CODLOCAL,
            this.selectedPreRegistration.CODATENDIMENTO
          );

          this.$vs.notify({
            title: "Sucesso",
            text: "Taxa reenviada com sucesso.",
            color: "success",
            position: "top-center",
          });
        })
        .catch((error) => {
          notifyError(this, "Erro ao tentar reenviar a taxa: " + error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async resendTaxWhats() {
      this.showDetail = false;
      this.$vs.loading();
      const payload = {
        colligateId: this.selectedPreRegistration.CODCOLIGADA,
        preRegistrationId: this.selectedPreRegistration.IDPREMATRICULA,
        contractId: this.selectedPreRegistration.CODCONTRATO,
        ra: this.selectedPreRegistration.RA,
        workflow: "363",
      };
      await new Financial()
        .resendTax(payload)
        .then(() => {
          onlyUpdateDiscussion(
            "Taxa reenviada para o WhatsApp: " + this.clientResult.TELEFONE1,
            this.selectedPreRegistration.CODCOLIGADA,
            this.selectedPreRegistration.CODLOCAL,
            this.selectedPreRegistration.CODATENDIMENTO
          );

          this.$vs.notify({
            title: "Sucesso",
            text: "Taxa reenviada com sucesso.",
            color: "success",
            position: "top-center",
          });
        })
        .catch((error) => {
          notifyError(this, "Erro ao tentar reenviar a taxa: " + error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    startEditPre(
      pre,
      codAtendimento,
      codColigada,
      codLocal,
      preRegistrationId
    ) {
      this.$vs.loading();
      new preRegistration()
        .getSubjects(pre.CODCOLIGADA, pre.IDPREMATRICULA)
        .then(({ data }) => {
          this.subjects = Array.isArray(data) ? data : [data];
          this.$vs.loading.close();

          updateStepsInformation({
            codAtendimento: codAtendimento,
            codColigada: codColigada,
            codLocal: codLocal,
            preRegistrationIdEdit: preRegistrationId,
            edit: true,
            levelC: "C",
            preRegistration: this.selectedPreRegistration,
            preRegistrationSubjects: this.subjects,
          });
          this.$router.push("/tax");
        })
        .catch(({ error }) => {
          this.error = true;
          this.errors.push(error.message);
          this.$vs.loading.close();
        });
    },

    async aprove() {
      this.successAdvance = false;
      await this.advance("AP");
      if (this.successAdvance) {
        this.message = "Aprovação realizada com sucesso.";
        this.successAdvance = false;
        await this.advance("SE");
        if (this.successAdvance) {
          notifySuccess(
            this,
            "Pré-matrícula encaminhada para secretaria, aguardando pagamento da taxa!"
          );
          this.showDetail = false;
          this.findBy();
        } else {
          this.error = true;
          this.errors.push(
            "Ocorreu um erro inesperado ao aprovar negociação. Por favor contate o suporte."
          );
        }
      }
    },

    async cancel() {
      this.$vs.loading();
      const payload = {
        reasonId: "18",
        coligateId: this.selectedPreRegistration.CODCOLIGADA,
        localId: this.selectedPreRegistration.CODLOCAL,
        attendanceId: this.selectedPreRegistration.CODATENDIMENTO,
      };
      new preRegistration()
        .cancel(payload, this.selectedPreRegistration.IDPREMATRICULA)
        .then(() => {
          notifySuccess(this, "Pré-matrícula cancelada com sucesso");
          this.showDetail = false;
          this.findBy();
        })
        .catch((error) => {
          notifyError(
            this,
            "Erro ao tentar cancelar a pré-matrícula: " + error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    async openDivergence(info) {
      this.divergenceInfo = info;
      this.editDivergence = true;
      this.correctionDivergence = null;
    },

    async divergenceCorrected(correction) {
      this.$vs.loading();
      const payloadParams = {
        CODLOCAL: this.divergenceInfo.CODLOCAL,
        CODCOLIGADA: this.divergenceInfo.CODCOLIGADA,
        CODATENDIMENTO: this.divergenceInfo.CODATENDIMENTO,
        CODCOLIGADARESP: this.divergenceInfo.CODCOLIGADAATENDENTERESP,
        CODATENDENTERESP: this.divergenceInfo.CODATENDENTERESP,
        PARAMETRO_230: correction,
      };

      new Mailing()
        .updateParamsAttendance(payloadParams)
        .then(() => {
          const payloadDivergence = {
            CODCOLIGADA: this.divergenceInfo.CODCOLIGADA,
            CODLOCAL: this.divergenceInfo.CODLOCAL,
            CODATENDIMENTO: this.divergenceInfo.CODATENDIMENTO,
            CODTIPOATENDIMENTO: this.divergenceInfo.CODTIPOATENDIMENTO,
            IDPREMATRICULA: this.divergenceInfo.IDPREMATRICULA,
            CODUSUARIO: this.divergenceInfo.USUVENDEDOR,
          };
          new preRegistration()
            .audit(payloadDivergence)
            .then(() => {
              notifySuccess(this, "Pré-matrícula encaminha para auditoria!");
              this.showDetail = false;
              this.findBy();
            })
            .catch((error) => {
              this.error = true;
              this.errors.push({ error: error.response.data.error });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        })
        .catch((error) => {
          this.error =
            "Erro ao alterar a correção de divergência: " +
            error.response.data.error;
          this.$vs.loading.close();
        });
    },

    async gotoSecretary() {
      this.successAdvance = false;
      await this.advance("SE");
      if (this.successAdvance) {
        notifySuccess(
          this,
          "Pré-matrícula reservada, aguardando pagamento da taxa!"
        );
        this.showDetail = false;
        this.findBy();
      }
    },

    resetSelectedPre() {
      this.selectedPreRegistration = {
        CODCOLIGADA: "",
        IDPREMATRICULA: "",
        CODATENDIMENTO: "",
        NUMPARCELA: "",
        VALORPARCELA: "",
        VALORTAXA: "",
        DTVENCIMENTOTAXA: "",
        DTVENCIMENTOPARC: "",
        EDITAVEL: "",
        RELANCAR: "",
        DESCARTAR: "",
        USUSUPERVISOR: "",
        CONTEXTO: "",
        APROVAR: "",
        AVANCAR: "",
        USUTELEAGENDADOR: "",
        USUVENDEDOR: "",
      };
    },

    async reprove() {
      this.successAdvance = false;
      await this.advance("RP");
      if (this.successAdvance) {
        notifySuccess(this, "Negociação reprovada.");
        this.showDetail = false;
        this.findBy();
      } else {
        this.errors.push(
          "Ocorreu um erro inesperado ao reprovar negociação. Por favor contate o suporte."
        );
      }
    },

    async openDetail(pre) {
      this.emailEdited = null;
      this.telephoneEdited = null;
      this.editDivergence = false;
      this.editEmail = false;
      this.editTelephone = false;
      this.showDetail = true;
      this.successAdvance = false;
      this.scholarships = null;
      this.hasScholarships = false;
      this.resetSelectedPre();
      this.error = null;
      this.errors.length = 0;
      this.$vs.loading();
      await new preRegistration()
        .getPreRegistration(pre.CODCOLIGADA, pre.IDPREMATRICULA)
        .then(({ data }) => {
          this.selectedPreRegistration = data;
          this.discussion = this.selectedPreRegistration?.TEXTODISCUSSAO?.replaceAll(
              "\n",
              "<br />"
            );
          this.payTax = pre.DATABAIXA;
          Object.assign(this.selectedPreRegistration, pre);
          this.$vs.loading.close();
        })
        .catch(({ error }) => {
          this.error = true;
          this.error = error?error.message:"houve um erro inesperado! Contate o suporte.";
          this.$vs.loading.close();
        });
      this.$vs.loading();
      await new PersonService()
        .getPerson(
          this.selectedPreRegistration.CPFCLIENTE,
          null,
          this.selectedPreRegistration.CODCURSO,
          "C"
        )
        .then(({ data }) => {
          this.clientResult = data;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      this.$vs.loading();
      await new preRegistration()
        .getScholarships(pre.CODCOLIGADA, pre.IDPREMATRICULA)
        .then(({ data }) => {
          this.scholarships = Array.isArray(data) ? data : [data];
          if (this.scholarships[0] != "") {
            this.hasScholarships = true;
            updateStepsInformation(this.scholarships);
          }
          this.$vs.loading.close();
        })
        .catch(({ error }) => {
          this.error = true;
          this.error = error?error.message:"houve um erro inesperado! Contate o suporte.";
          this.$vs.loading.close();
        });
    },

    async advance(type) {
      const pre = {
        colligateCod: this.selectedPreRegistration.CODCOLIGADA,
        localCod: this.selectedPreRegistration.CODLOCAL,
        nivel: type == "SE" ? "V" : this.selectedPreRegistration.NIVEL,
        attendanceCod: this.selectedPreRegistration.CODATENDIMENTO,
        type: type,
      };
      if (this.selectedPreRegistration.IDPREMATRICULA != "") {
        this.$vs.loading();
        await new preRegistration()
          .advance(pre, this.selectedPreRegistration.IDPREMATRICULA)
          .then(() => {
            this.successAdvance = true;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.error = true;
            this.errors.push({ error: error.response.data.error });
            this.$vs.loading.close();
          });
      } else {
        this.errors.push({
          error:
            "Não foi possível avançar etapa pois não foi localizado o id da pré-matrícula",
        });
      }
    },

    // CRIAR O MÉTODO confirmDisposal AQUI
    async confirmDisposal() {
      this.successAdvance = false;
      this.$vs.loading();
      let payload = {
        isDisposalReason: 9,
        coligateId: this.selectedPreRegistration.CODCOLIGADA,
        RELANCADA: 0,
      };
      await new preRegistration()
        .disposal(payload, this.selectedPreRegistration.IDPREMATRICULA)
        .then(() => {
          notifySuccess(
            this,
            "Pré matrícula descartada com sucesso! Cliente liberado."
          );
          this.showDetail = false;
          this.successAdvance = true;
          this.$vs.loading.close();
          this.findBy();
        })
        .catch((error) => {
          this.error = true;
          this.errors.push({ error: error.response.data.error });
          this.$vs.loading.close();
        });
    },

    init() {
      if (this.today < this.fortnight.middleDate) {
        this.date = {
          inicialDate: this.fortnight.inicialDate,
          finalDate: this.today,
        };
      } else {
        this.date = {
          inicialDate: this.fortnight.middleDate,
          finalDate: this.today,
        };
      }
      this.findBy();
    },
    async findBy() {
      this.statusFilter = null;
      this.taxFilter = null;
      this.sellerFilter = null;

      this.$vs.loading();
      await new preRegistration()
        .searchByDate(this.date)
        .then((res) => {
          this.myPreRegistation = res.data;
          this.$vs.loading.close();
        })
        .catch(({ error }) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
  },
  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scope>
.vs-col {
  padding: 10px;
  font-size: 0.8rem;
}
.h100 {
  line-height: 30px;
}
.b__important {
  font-weight: bolder;
}
.b__small {
  font-size: 10px;
  color: #607d8b;
}
.invicible {
  visibility: hidden;
}
.vs-popup--content {
  margin: 0;
  padding: 0;
}
.flex-gap {
  gap: 10px;
}
.spinner-container {
  display: flex;
  width: 100%;
}
.spinner {
  border: 1.85px solid rgba(0, 0, 0, 0.1);
  height: 10px;
  width: 10px;
  border-left-color: #9b0e1c;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
</style>
